import script from "./StepRightToWork.vue?vue&type=script&setup=true&lang=js"
export * from "./StepRightToWork.vue?vue&type=script&setup=true&lang=js"

import "./StepRightToWork.vue?vue&type=style&index=0&id=74b83784&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b83784"]])

export default __exports__